import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import "./css/NationSelector.css"

const NationSelector = ({ nations, selectedNation, setSelectedNation, allowCrossNationSelection = false }) => {
  const { user, isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (!Array.isArray(nations) || !nations.length || selectedNation?._id) return;
    const userNationId = typeof user?.nation === 'string' ? user.nation : user?.nation?._id;
    const defaultNation = nations.find((nation) => nation._id === userNationId) || nations[0] || null;
    if (defaultNation) setSelectedNation(defaultNation);
  }, [nations, selectedNation?._id, setSelectedNation, user?.nation]);

  // If the user is not authenticated or has a "user" role, hide the selector
  if (!isAuthenticated() || user.role === "user") {
    return null;
  }

  const handleNationChange = (e) => {
    const selectedNationId = e.target.value;
    const selectedNationObject = nations.find(nation => nation._id === selectedNationId);
    setSelectedNation(selectedNationObject);
  };

  if (user.role === "superUser" || user.role === "supporter" || allowCrossNationSelection) {
    return (
      <div className="nation-selector">
        <label htmlFor="nation-select">Select Nation: </label>
        <select
          id="nation-select"
          value={selectedNation?._id || ''}
          onChange={handleNationChange}
        >
          {nations.map((nation) => (
            <option key={nation._id} value={nation._id}>
              {nation.number}
            </option>
          ))}
        </select>
      </div>
    );
  } else {
    return (
      <div>
        <label>Nation: {selectedNation?.number || ''}</label>
      </div>
    );
  }
};

export default NationSelector;
